/* unplugin-vue-components disabled */import { ElDialog as __unplugin_components_11 } from 'element-plus/es';import 'element-plus/es/components/dialog/style/css';
import { ElButton as __unplugin_components_10 } from 'element-plus/es';import 'element-plus/es/components/button/style/css';
import { ElForm as __unplugin_components_9 } from 'element-plus/es';import 'element-plus/es/components/form/style/css';
import { ElInputNumber as __unplugin_components_8 } from 'element-plus/es';import 'element-plus/es/components/input-number/style/css';
import { ElTag as __unplugin_components_7 } from 'element-plus/es';import 'element-plus/es/components/tag/style/css';
import { ElInput as __unplugin_components_6 } from 'element-plus/es';import 'element-plus/es/components/input/style/css';
import { ElRadioGroup as __unplugin_components_5 } from 'element-plus/es';import 'element-plus/es/components/radio-group/style/css';
import { ElRadio as __unplugin_components_4 } from 'element-plus/es';import 'element-plus/es/components/radio/style/css';
import { ElSelect as __unplugin_components_3 } from 'element-plus/es';import 'element-plus/es/components/select/style/css';
import { ElOption as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/option/style/css';
import { ElFormItem as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/form-item/style/css';
import __unplugin_components_0 from '/Users/liao/work/cmge/ultrasdk/ultrasdk.hub.web/packages/base/src/components/GameChannelSelect/index.vue';
import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, isRef as _isRef, withKeys as _withKeys } from "vue";
const _hoisted_1 = {
  class: "dialog-footer"
};
import { apiUsdkCpsDistributeChannel, apiUsdkCpsChannelPackage, apiProjectCpsAdd } from '@/api/usdk';
import PackageInfoTemplate from './packageInfoTemplate.vue';
import DistributeForm from '../channelManage/distributeForm.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'createPack',
  props: {
    gid: {
      type: Number,
      default: 0
    }
  },
  emits: ['success'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const props = __props;
    const distributeFormRef = ref();
    const dialogVisible = ref(false);
    const confirmLoading = ref(false);
    const addForm = ref();
    const form = ref({
      cid: '',
      plId: '',
      distributeCid: '',
      createType: 1,
      projectNames: [],
      count: 1,
      cdnDomain: ''
    });
    const tempName = ref('');
    const packageInfo = ref();
    const packageList = ref();
    const cdnDomainList = ref([process.env.VUE_APP_OFFICIAL_CDN_DOMAIN]);
    // 分发渠道列表
    const distributeChannelList = ref([]);
    const emits = __emit;
    const initForm = () => {
      form.value = {
        cid: '',
        plId: '',
        distributeCid: '',
        createType: 1,
        projectNames: [],
        count: 1,
        cdnDomain: ''
      };
    };
    const handleChangeChannel = val => {
      packageInfo.value = {};
      packageList.value = [];
      getPackageList();
      getDistributeChannel(val);
    };
    // 输入自定义名称
    const handleInput = () => {
      if (tempName.value) {
        form.value.projectNames.push(tempName.value);
        tempName.value = '';
      }
    };
    // 获取分发渠道下拉列表
    const getDistributeChannel = cid => {
      apiUsdkCpsDistributeChannel({
        cid
      }).then(res => {
        if (res.code === 0) {
          distributeChannelList.value = res.data;
        } else {
          distributeChannelList.value = [];
        }
      });
    };
    // 创建分包获取游戏包
    const getPackageList = () => {
      if (!props.gid || !form.value.cid) {
        return;
      }
      const params = {
        gid: props.gid,
        cid: form.value.cid
      };
      apiUsdkCpsChannelPackage(params).then(res => {
        if (res.code === 0) {
          packageList.value = res.data;
          form.value.plId = res.data[0] && res.data[0].id;
          packageInfo.value = res.data[0] || {};
        }
      });
    };
    const handlePackage = (item, option) => {
      packageInfo.value = option && option.data && option.data.attrs.data || {};
    };
    const delName = (e, index) => {
      e.preventDefault();
      form.value.projectNames.splice(index, 1);
    };
    const handleClose = () => {
      dialogVisible.value = false;
      packageList.value = [];
      packageInfo.value = {};
      initForm();
    };
    const handleOk = formEl => {
      if (!formEl) return;
      formEl.validate(valid => {
        if (valid) {
          let params = JSON.parse(JSON.stringify(form.value));
          params.gid = props.gid;
          if (params.createType === 2) {
            params.count = params.projectNames.length;
            params.projectNames = params.projectNames.join(',');
          }
          params.distributeName = distributeChannelList.value.filter(item => item.cid === params.distributeCid)[0].title;
          confirmLoading.value = true;
          apiProjectCpsAdd(params).then(res => {
            if (res.code === 0) {
              emits('success');
              handleClose();
            }
          }).finally(() => {
            confirmLoading.value = false;
          });
        }
      });
    };
    const handleAddChannel = () => {
      distributeFormRef.value.show();
    };
    const show = () => {
      dialogVisible.value = true;
    };
    __expose({
      show
    });
    return (_ctx, _cache) => {
      const _component_GameChannelSelect = __unplugin_components_0;
      const _component_el_form_item = __unplugin_components_1;
      const _component_el_option = __unplugin_components_2;
      const _component_el_select = __unplugin_components_3;
      const _component_el_radio = __unplugin_components_4;
      const _component_el_radio_group = __unplugin_components_5;
      const _component_el_input = __unplugin_components_6;
      const _component_el_tag = __unplugin_components_7;
      const _component_el_input_number = __unplugin_components_8;
      const _component_el_form = __unplugin_components_9;
      const _component_el_button = __unplugin_components_10;
      const _component_el_dialog = __unplugin_components_11;
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_el_dialog, {
        title: "官方分包",
        modelValue: _unref(dialogVisible),
        "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => _isRef(dialogVisible) ? dialogVisible.value = $event : null),
        width: "700px",
        "before-close": handleClose
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_1, [_createVNode(_component_el_button, {
          onClick: handleClose
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        }), _createVNode(_component_el_button, {
          loading: _unref(confirmLoading),
          type: "primary",
          onClick: _cache[7] || (_cache[7] = $event => handleOk(_unref(addForm)))
        }, {
          default: _withCtx(() => [_createTextVNode("确定")]),
          _: 1
        }, 8, ["loading"])])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          ref_key: "addForm",
          ref: addForm,
          model: _unref(form),
          "label-width": "120px"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "联运渠道",
            prop: "cid",
            rules: {
              required: true,
              message: '选择渠道',
              trigger: 'change'
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_GameChannelSelect, {
              style: {
                "width": "100%"
              },
              gid: __props.gid,
              modelValue: _unref(form).cid,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(form).cid = $event),
              onChange: handleChangeChannel,
              otherProps: {
                isHero: 1,
                needIos: 0
              }
            }, null, 8, ["gid", "modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "渠道包信息",
            prop: "plId",
            rules: {
              required: true,
              message: '选择包名',
              trigger: 'change'
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              style: {
                "width": "100%"
              },
              clearable: "",
              modelValue: _unref(form).plId,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _unref(form).plId = $event),
              placeholder: "选择渠道包",
              onChange: handlePackage
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(packageList), item => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: item.id,
                  value: item.id,
                  label: item.title
                }, null, 8, ["value", "label"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _unref(form).plId ? (_openBlock(), _createBlock(PackageInfoTemplate, {
            key: 0,
            packageInfo: _unref(packageInfo)
          }, null, 8, ["packageInfo"])) : _createCommentVNode("", true), _createVNode(_component_el_form_item, {
            label: "分发渠道",
            prop: "distributeCid",
            rules: {
              required: true,
              message: '选择分发渠道',
              trigger: 'change'
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              disabled: !_unref(form).cid,
              placeholder: "选择分发渠道",
              modelValue: _unref(form).distributeCid,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _unref(form).distributeCid = $event),
              style: {
                "width": "100%"
              }
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(distributeChannelList), item => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: item.cid,
                  value: item.cid,
                  label: item.title
                }, null, 8, ["value", "label"]);
              }), 128))]),
              _: 1
            }, 8, ["disabled", "modelValue"]), _createElementVNode("span", null, [_createTextVNode("未找到可用渠道，点我"), _createElementVNode("a", {
              href: "javascript:;",
              onClick: handleAddChannel
            }, "创建")])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            class: "text-center",
            prop: "createType"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_radio_group, {
              modelValue: _unref(form).createType,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _unref(form).createType = $event)
            }, {
              default: _withCtx(() => [_createVNode(_component_el_radio, {
                label: 1
              }, {
                default: _withCtx(() => [_createTextVNode("系统生成名称")]),
                _: 1
              }), _createVNode(_component_el_radio, {
                label: 2
              }, {
                default: _withCtx(() => [_createTextVNode("自定义名称")]),
                _: 1
              })]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _unref(form).createType === 2 ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 1,
            label: "自定义名称",
            prop: "projectNames",
            rules: {
              required: true,
              message: '请输入自定义名称',
              trigger: 'blur'
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              class: "marginB10",
              modelValue: _unref(tempName),
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _isRef(tempName) ? tempName.value = $event : null),
              onKeydown: _withKeys(handleInput, ["enter"]),
              placeholder: "请输入自定义名称, 按回车添加"
            }, {
              append: _withCtx(() => [_createTextVNode("已添加 " + _toDisplayString(_unref(form).projectNames.length) + " 个", 1)]),
              _: 1
            }, 8, ["modelValue"]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(form).projectNames, (item, index) => {
              return _openBlock(), _createBlock(_component_el_tag, {
                class: "marginR10",
                closable: "",
                key: index,
                onClose: $event => delName($event, index)
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(item), 1)]),
                _: 2
              }, 1032, ["onClose"]);
            }), 128))]),
            _: 1
          })) : (_openBlock(), _createBlock(_component_el_form_item, {
            key: 2,
            label: "分包数量",
            prop: "count",
            rules: {
              required: true,
              message: '请输入分包数量',
              trigger: 'blur'
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input_number, {
              class: "width100",
              modelValue: _unref(form).count,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => _unref(form).count = $event),
              min: 1,
              placeholder: "请输入整数"
            }, null, 8, ["modelValue"])]),
            _: 1
          })), _createVNode(_component_el_form_item, {
            label: "CDN域名",
            prop: "cdnDomain"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              style: {
                "width": "100%"
              },
              placeholder: "选择域名",
              modelValue: _unref(form).cdnDomain,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => _unref(form).cdnDomain = $event)
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(cdnDomainList), item => {
                return _openBlock(), _createBlock(_component_el_option, {
                  value: item,
                  key: item,
                  label: item
                }, null, 8, ["value", "label"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"])]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(DistributeForm, {
        ref_key: "distributeFormRef",
        ref: distributeFormRef
      }, null, 512)], 64);
    };
  }
});